import { render, staticRenderFns } from "./button-bar.vue?vue&type=template&id=4d981415&"
import script from "./button-bar.vue?vue&type=script&lang=js&"
export * from "./button-bar.vue?vue&type=script&lang=js&"
import style0 from "./button-bar.vue?vue&type=style&index=0&id=4d981415&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports